<template>
    <div>
        <div v-if="$route.path.indexOf('_editor') === -1">
            <el-row :gutter="20">
                <el-col :md="4" :lg="8">
                    <el-button size="mini" type="primary" icon="plus" @click="addGive">添加充值赠送</el-button>
                </el-col>
            </el-row>
            <el-tabs type="border-card" v-model="activeName">

                <el-table :data="list" style="width: 100%" v-loading="loading" element-loading-text="数据加载中">
                    <el-table-column prop="id" width="60" label="编号"></el-table-column>
                    <el-table-column prop="line_name" label="活动名称"></el-table-column>
                    <el-table-column prop="line_many" label="赠送金额"></el-table-column>
                    <el-table-column prop="items" label="关联商品">
                        <template slot-scope="scope">

                            <el-button type="text" @click="handleDialogGoods(scope.row,scope.row.id)">查看商品</el-button>

                        </template>
                    </el-table-column>

                    <el-table-column label="是否开启" width="120" show-overflow-tooltip >
                        <template slot-scope="scope">
                              <el-switch
                                v-model="scope.row.status"
                                :active-value="1" :inactive-value="0"
                                active-color="#13ce66"
                                inactive-color="#ff4949"
                                @change="switchRecord(scope.$index, scope.row)"
                                >
                              </el-switch>
                        </template>
                    </el-table-column>

                    <el-table-column label="开始时间" width="200">
                        <template slot-scope="scope">
                            <span>{{scope.row.start_time|datetime('yyyy-MM-dd hh:mm:ss')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="结束时间" width="200">
                        <template slot-scope="scope">
                            <span>{{scope.row.end_time|datetime('yyyy-MM-dd hh:mm:ss')}}</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作" width="150">
                        <template slot-scope="scope">
                            <div class="operating-icons">
                                <el-button @click="updateGive(scope.row)" type="text">编辑
                                </el-button>
                                <el-button @click="deleteGive(scope.row.id)" type="text">刪除
                                </el-button>
                                <!-- <el-button @click="showGiveLog(scope.row)" type="text">查看发放记录
                                </el-button> -->
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div v-if="total_count > params.pageSize" class="content-padded content-center">
                    <el-pagination
                            layout="prev, pager, next"
                            @current-change="handleCurrentChange"
                            :current-page.sync="params.page"
                            :total='total_count' :page-size="params.pageSize">
                    </el-pagination>
                </div>
            </el-tabs>
        </div>
        <router-view></router-view>


        <el-dialog :title="goodsDialog.goodsTitle" :visible.sync="goodsDialog.goodsVisible"  :before-close="handleGoodsDialogCancel">
            <el-row
                    title="商品列表"
                    type="info"
                    description=""
                    show-icon>
            </el-row>
            <el-row :gutter="10" v-loading="goodsDialog.dialogLoading">
                <el-col :md="23">
                    <el-table ref="multipleTable" :data="goodsList" style="width: 100%" tooltip-effect="dark">
                        <!--<el-table-column type="selection" width="55" > </el-table-column>-->
                        <el-table-column prop="item_id" label="商品id" v-if="false"></el-table-column>
                        <el-table-column prop="item_name" label="商品名称" width="100">
                            <template slot-scope="scope">
                                <router-link :to="{ path: matchInternalRoute('goodsphysical_editor')+ '/' + scope.row.item_id}" class="btn-gap">{{scope.row.item_name}}</router-link>
                            </template>
                        </el-table-column>
                        <el-table-column prop="item_bn" label="商品编号">
                            <template slot-scope="scope" style="white-space: nowrap"><div v-show="false">商品id:{{scope.row.item_id}}</div>{{scope.row.item_bn}}</template>
                        </el-table-column>
                        <el-table-column prop="item_bn" label="商品来源">
                            <template slot-scope="scope">
                                <el-tag size="mini" effect="plain" type="success" v-if="scope.row.item_from=='store'">店铺</el-tag>
                                <el-tag size="mini" effect="plain" type="success" v-else-if="scope.row.item_from=='shop'">商城</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="brief" label="商品简介" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="price" label="销售价格"></el-table-column>
                        <el-table-column prop="market_price" label="市场价格"></el-table-column>
                        <el-table-column prop="is_record" label="商品图片" width="90" >
                            <template slot-scope="scope">
                                <el-popover
                                        placement="right"
                                        width="240"
                                        trigger="hover" >
                                    <div style="overflow-y: scroll;overflow-x: hidden;height:240px;text-align:center;">
                                        <img  :src="v" class="goods-popover-img" style="width:92%;" v-for="v in scope.row.pics">
                                    </div>
                                    <el-button type="text" slot="reference"><img src="/static/img/icon_img.png" ></el-button>
                                </el-popover>
                            </template>
                        </el-table-column>

                    </el-table>
                    <div class="content-center content-top-padded" v-show="false">
                        <el-pagination
                                background
                                layout="total, sizes, prev, pager, next"
                                @current-change="handleGoodsDialogCurrentChange"
                                @size-change="handleGoodsDialogSizeChange"
                                :current-page.sync="goodsDialog.goodsParams.page"
                                :page-sizes="[100,200,300]"
                                :total="goodsList.total_count"
                                :page-size="goodsDialog.goodsParams.pageSize">
                        </el-pagination>
                    </div>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer position-left">
              <el-button @click="goodsDialog.goodsVisible = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import {cancelGive, getGive, updateGive,getGiveGoods} from '../../../../api/promotions'

  export default {
    data() {
      return {
        loading: false,
        activeName: 'all',
        params: {
          page: 1,
          pageSize: 20
        },
        goodsList:[],
        goodsDialog:{
            dialogLoading:true,
            goodsTitle:'',
            goodsVisible:false,
            goodsParams:{
                page:1,
                pageSize:20,
            },
        },
        total_count: 0,
        list: [],
      }
    },
    methods: {

      handleCurrentChange(val) {
        this.params.page = val
        this.loading = false
        this.getGiveLists()
      },
      addGive() {
        this.$router.push({path: this.matchHidePage('editor')})
      },
      updateGive(row) {
        this.$router.push({path: this.matchHidePage('editor/') + row.id})
      },
      // showGiveLog(row)
      // {
      //   this.$router.push({path: this.matchHidePage('logs/') + row.id})
      // },
      deleteGive(id)
      {
         cancelGive(id).then(res => {
             if (res.data.status) {
                 this.$message({
                     message: '操作成功',
                     type: 'success',
                     duration: 2 * 1000
                 })
                 this.getGiveLists()
             }
         })
      },
      getGiveLists() {
        this.loading = true
        getGive(this.params).then(res => {
          this.loading = false
          this.list = res.data.data.list
          this.total_count = res.data.data.total_count
        })
      },
      // 商品
      handleGoodsDialogCancel(){
          this.goodsDialog.goodsVisible = false
      },
      handleGoodsDialogCurrentChange (page_num) {
          this.params.page = page_num
      },
      handleGoodsDialogSizeChange (pageSize) {
          this.params.page = 1
          this.params.pageSize = pageSize
      },
      switchRecord(index, row) {
          let params = {
              'status': row.status,
          }
          updateGive(row.id,params).then(res => {
              if (res.data.data.status) {
                  this.$message({
                      message: '操作成功',
                      type: 'success',
                      duration: 2 * 1000
                  })
                  this.getGiveLists()
              }
          })
      },
      handleDialogGoods(row,id) {
          this.goodsList = [];
          this.rowData = row;
          this.goodsDialog.goodsTitle = '(id:'+row.id + ')' + row.line_name;
          this.goodsDialog.dialogLoading = true
          this.goodsDialog.goodsVisible = true
          this.goodsDialog.goodsParams.page = 1
          this.goodsDialog.goodsParams.pageSize = 10
          getGiveGoods({'id':id}).then(res=>{
              if(res.data.data){
                  this.goodsDialog.dialogLoading = false
                  this.goodsList = res.data.data;
              }
          });

      },


    },
    mounted() {
      this.getGiveLists()
    }
  }
</script>



// WEBPACK FOOTER //
// list.vue?0633f54c